module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.05e59a63.ttf";